<div class="container-fluid mt-3">
  <div *ngIf="schedule" class="d-flex flex-column">
    <div class="d-flex flex-row">
      <strong class="col-3">Type: </strong>
      <div class="offset-md-1 mb-1">{{ schedule.type }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3">Week Days: </strong>
      <div class="offset-md-1 mb-1">
        {{ schedule && schedule.weekDays ? (schedule.weekDays.length > 0 ? schedule.weekDays.join(', ') : '') : '' }}
      </div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3">Start Date: </strong>
      <div class="offset-md-1 mb-1">{{ schedule?.startDateTime | date: 'MM/dd/yyyy hh:mm a' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3">End Date: </strong>
      <div class="offset-md-1 mb-1">{{ schedule?.endDateTime | date: 'MM/dd/yyyy hh:mm a' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3">Time: </strong>
      <div class="offset-md-1 mb-1">{{ schedule?.time | date: 'hh:mm a' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3">Interval: </strong>
      <div class="offset-md-1 mb-1">{{ schedule?.interval ? schedule?.interval + ' Min' : 'N/A' }}</div>
    </div>
    <div *ngIf="schedule && !schedule.lastDayOfTheMonth" class="d-flex flex-row">
      <strong class="col-3">Day of the Month: </strong>
      <div class="offset-md-1 mb-1"> {{ schedule?.dayOfTheMonth || 'N/A' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3">Last Day of the Month: </strong>
      <div class="offset-md-1 mb-1">{{ schedule?.lastDayOfTheMonth ? 'Yes' : 'No' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3"> </strong>
      <div class="offset-md-1 mb-1"></div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-3"> </strong>
      <div class="offset-md-1 mb-1"></div>
    </div>
  </div>
  <ng-container *ngIf="!schedule">
    <h3 class="font-weight-bolder">This report is not scheduled</h3>
  </ng-container>
</div>
